// Opportunity Forecast API
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    ForecastType,
} from 'app/Apps/Forecast/Forecast.types'

type OpportunityForecastRequests = {
    get: RequestConfigFunction<{ id: number }>,
    getForecastOngoingOpportunities: RequestConfigFunction<undefined>,
    getAll: RequestConfigFunction<Record<string, any>>,
    bulkUpdate: RequestConfigFunction<{ data?: { items: ForecastType[] } }>,
    forecastUpdate: RequestConfigFunction<{ id: number }>,
    filterCount: RequestConfigFunction<{ fieldName: string }>,
    getCurrentMonth: RequestConfigFunction<{ id: number }>,
    updateCurrentMonth: RequestConfigFunction<{ id: number }>,
}

const opportunityForecastRequests: OpportunityForecastRequests = {
    get: ({
        id,
    }) => {
        return {
            url: `opportunity/forecast/${id}`,
            method: 'GET',
        }
    },
    getForecastOngoingOpportunities: () => {
        return {
            url: 'opportunity/forecast/filter-request/ongoing-opportunities',
            method: 'POST',
        }
    },
    getAll: (params) => {
        return {
            url: 'opportunity/forecast/filter-request/spreadsheet',
            method: 'POST',
            ...params,
        }
    },
    bulkUpdate: ({
        data,
    } = {}) => {
        return {
            url: 'opportunity/forecast/spreadsheet/bulk',
            method: 'PATCH',
            data,
        }
    },
    forecastUpdate: ({
        id,
    }) => {
        return {
            url: `opportunity/forecast/${id}`,
            method: 'PATCH',
        }
    },
    filterCount: ({
        fieldName,
    }) => {
        return {
            url: `opportunity/forecast/filter-request/submission/count/${fieldName}`,
            method: 'POST',
            data: {
                rangeType: '',
            },
        }
    },
    getCurrentMonth: ({
        id,
    }) => {
        return {
            url: `opportunity/forecast/${id}/current-month`,
            method: 'GET',
        }
    },
    updateCurrentMonth: ({
        id,
    }) => {
        return {
            url: `opportunity/forecast/${id}/current-month`,
            method: 'PATCH',
        }
    },
}

export default opportunityForecastRequests
